import axios from './index'

class cases{
    //案例库关键字查询
    static searchCase(options) {
        return axios.get('/nice-api-cases/v1/actual', {params:options})
    }
    //查询热门品类
    static getCategory(options) {
        return axios.get('/nice-api-curing-service/v1/common/category/second/hot', {params:options})
    }

    //查询品牌
    static getBrand(options) {
        return axios.get('/nice-api-curing-service/v1/common/brand/hot', {params:options})
    }

    //查询症状
    static symptom(options) {
        return axios.get('/nice-api-curing-service/v1/common/symptom/hot', {params:options})
    }

    //查询品类树结构
    static categoryTree(options) {
        return axios.get('/nice-api-curing-service/v1/common/category/tree', {params:options})
    }
    
    //查询品牌more
    static getBrandMore(options) {
        return axios.get('/nice-api-curing-service/v1/common/brand/letter/order', {params:options})
    }
     
    //查询精确案例匹配
    static getExact(options) {
        return axios.get('/nice-api-cases/v1/actual', {params:options})
    }
    
    //查询精选案例（与上面格式不同）
    static getClassic(options) {
        return axios.get('/nice-api-cases/v1/classic', {params:options})
    }
    
    //精选案例详情
    static classicDetail(options) {
        return axios.get(`/nice-api-cases/v1/classic/${options}`)
    }
    
    //点赞
    static exactZan(options) {
        return axios.patch(`/nice-api-cases/v1/actual/${options}/zan`)
    }
    //取消点赞
    static unexactZan(options) {
        return axios.patch(`/nice-api-cases/v1/actual/${options}/zan/cancel`)
    }

    //获取颜色
    static getColor(options) {
        return axios.get(`/nice-api-curing-service/v1/common/color`)
    }

    //获取颜色
    static getScendCatogery(options) {
        return axios.get(`/nice-api-curing-service/v1/common/category`,{params:options})
    }

    //获取颜色
    static getMaterial(options) {
        return axios.get(`/nice-api-curing-service/v1/common/material`,{params:options})
    }
    
    //获取搜索条件
    static getSearchNav(options) {
        return axios.get(`/nice-api-curing-service/v1/curingServiceGoods/${options}/conditions`)
    }

    //根据服务项ID查询养护服务ID
    static curingServiceGoodsId(options) {
        return axios.get(`/nice-api-curing-service/v1/curingService/${options}/curingServiceGoodsId`)
    }
    static getActivityStand(params){
        return axios.get(`/nice-api-curing-service/v1/curingServiceGoods/activityStand`)
    }
}

export default cases;
